<template>
  <nav v-if="isLoggedIn" class="navbar navbar-expand-lg bg-body-tertiary rounded">
    <div class="container-fluid">
      <router-link class="navbar-brand" :to="{name: 'Dashboard'}" @click="collapseMenu">
        <img width="120" src="../assets/images/payer.svg" alt="Payer Online"/>
      </router-link>

      <button class="navbar-toggler" type="button" @click="toggleMenu">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" :class="{show: isMenuOpen}" id="navbarContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link class="nav-link" :to="{name: 'TransactionList'}" @click="collapseMenu">
              <i class="bi bi-arrow-left-right me-1"></i>Транзакции
            </router-link>
          </li>

          <template v-if="hasExtendedAccess">
            <li class="nav-item">
              <router-link class="nav-link" :to="{name: 'PaySystemList'}" @click="collapseMenu">
                <i class="bi bi-credit-card me-1"></i>Платежные системы
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{name: 'KktList'}" @click="collapseMenu">
                <i class="bi bi-receipt-cutoff me-1"></i>Касса
              </router-link>
            </li>
          </template>

          <template v-if="isAdmin">
            <li v-if="false" class="nav-item">
              <router-link class="nav-link" :to="{name: 'UserList'}" @click="collapseMenu">
                <i class="bi bi-people-fill me-1"></i>Пользователи
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{name: 'CompanyList'}" @click="collapseMenu">
                <i class="bi bi-building me-1"></i>Компании
              </router-link>
            </li>
          </template>
        </ul>

        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link v-if="isLoggedIn && currentUser" class="nav-link" :to="{name: 'Profile'}" @click="collapseMenu">
              <i class="bi bi-person-fill me-1"></i>{{ currentUser.name }}
            </router-link>
          </li>
          <li class="nav-item">
            <button class="nav-link btn btn-link" @click="collapseMenu(); logOut();">
              <i class="bi bi-box-arrow-right me-1"></i>Выйти
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import {AuthActionTypeEnum} from "@/store/modules/auth";

export default {
  name: "PayerTopNavBar",
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    currentUser: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      isMenuOpen: false
    }
  },
  computed: {
    isAdmin() {
      return this.currentUser && this.currentUser.role === 'ROLE_ADMIN';
    },
    isMerchant() {
      return this.currentUser && this.currentUser.role === 'ROLE_MERCHANT';
    },
    hasExtendedAccess() {
      return this.isAdmin || this.isMerchant;
    }
  },
  methods: {
    async logOut() {
      try {
        // Сбрасываем состояние перед выходом
        this.$emit('user-logout');

        // Ждем завершения операции выхода
        await this.$store.dispatch(AuthActionTypeEnum.logout);

        // Перенаправляем только после успешного выхода
        this.$router.push({name: 'Login'});
      } catch (error) {
        console.error("Logout failed:", error);
        // Обработка ошибки выхода
      }
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    collapseMenu() {
      // Сворачиваем меню только на мобильных устройствах и планшетах
      if (window.innerWidth < 992) {
        this.isMenuOpen = false;
      }
    }
  }
}
</script>

<style scoped>
.navbar-toggler {
  border: none;
}

.btn-link {
  text-decoration: none;
  color: inherit;
  padding: 0.5rem 1rem;
}

/* Улучшения для мобильных устройств */
@media (max-width: 991.98px) {
  .navbar-nav {
    margin-top: 0.5rem;
  }

  .nav-link, .btn-link {
    padding: 0.75rem 1.25rem;
    font-size: 1.1rem;
  }

  .navbar-collapse {
    background-color: #f8f9fa;
    border-radius: 0.5rem;
    padding: 1rem;
    margin-top: 0.5rem;
    box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);
  }

  .navbar-nav .nav-item {
    border-bottom: 1px solid #e9ecef;
  }

  .navbar-nav .nav-item:last-child {
    border-bottom: none;
  }
}

/* Анимация иконки бургер-меню */
.navbar-toggler:focus {
  box-shadow: none;
}

.navbar-toggler-icon {
  transition: transform 0.3s ease;
}

.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
  transform: rotate(90deg);
}

/* Плавная анимация раскрытия/сворачивания */
.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (max-width: 991.98px) {
  .collapsing {
    transition: none;
  }
}
</style>